import React, { useState, useEffect } from 'react'
import Page from '../../components/Page'
import {
  StyledField,
  StyledFooterButton,
  StyledInput,
  StyledLabel,
  StyledSubmitButton
} from '../shop/collections/components/Detail/styles'
import Form, { Field, ErrorMessage } from '@atlaskit/form'
import { StyledFooter } from './styles'
import { useQuery } from '@apollo/react-hooks'
import { STUFFS } from './utils/queries'

const Auth = () => {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [errorOnSubmit, setErrorOnSubmit] = useState(false)
  const { data, loading, error, refetch } = useQuery(STUFFS, {
    variables: {
      where: {
        login,
        password
      },
      first: 1
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      data && (login || password) && setErrorOnSubmit(true)
    }
  })

  const stuffs = (data || {}).stuffs || []

  useEffect(() => {
    if (!stuffs.length) return
    const { id, type } = stuffs[0]
    localStorage.setItem(
      'stuff',
      JSON.stringify({
        id,
        type
      })
    )
    window.location.href = '/'
  }, [stuffs.length])

  const onFormSubmit = ({ login, password }) => {
    setLogin(login)
    setPassword(password)
    refetch()
  }

  return (
    <Page
      style={{
        margin: '0 auto',
        maxWidth: '400px',
        position: 'relative',
        top: '50%',
        height: '50%',
        transform: 'translateY(-50%)'
      }}
      navigation={false}
      auth={true}
    >
      <Form onSubmit={onFormSubmit}>
        {({ formProps, submitting }) => (
          <form {...formProps}>
            <>
              <StyledField>
                <Field
                  name={'login'}
                  label={undefined}
                  defaultValue={''}
                  isRequired={false}
                  validate={value => undefined}
                >
                  {({ fieldProps }) => (
                    <>
                      <StyledLabel>Логин</StyledLabel>
                      <StyledInput
                        value={fieldProps.value}
                        onChange={value => fieldProps.onChange(value)}
                      />
                    </>
                  )}
                </Field>
              </StyledField>
              <StyledField>
                <Field
                  name={'password'}
                  label={undefined}
                  defaultValue={''}
                  isRequired={false}
                  validate={value => undefined}
                >
                  {({ fieldProps }) => (
                    <>
                      <StyledLabel>Пароль</StyledLabel>
                      <StyledInput
                        type="password"
                        value={fieldProps.value}
                        onChange={value => fieldProps.onChange(value)}
                      />
                    </>
                  )}
                </Field>
              </StyledField>
            </>
            {errorOnSubmit && !stuffs.length && (
              <ErrorMessage>Неправильный логин или пароль!</ErrorMessage>
            )}
            <StyledFooter>
              <StyledFooterButton>
                <span />
                <StyledSubmitButton type="submit" disabled={submitting}>
                  Войти
                </StyledSubmitButton>
              </StyledFooterButton>
            </StyledFooter>
          </form>
        )}
      </Form>
    </Page>
  )
}
export default Auth
